export default __webpack_public_path__ + "static/media/opencv.8cb41278.svg";